/** @format */

import React from 'react'

import {allFieldTypes, FieldType, getIconByFieldType} from '../FieldType'

type FieldTypePickerProps = {
  onSelect: (newSelection: FieldType) => void
}

export function FieldTypePicker({onSelect}: FieldTypePickerProps) {
  return (
    <>
      <p>Select a field in your form to validate with each submission.</p>
      <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2">
        {allFieldTypes.map(fieldType => (
          <FieldTypeOption
            key={fieldType.key}
            fieldType={fieldType}
            onSelect={() => onSelect(fieldType)}
          />
        ))}
      </div>
    </>
  )
}

function FieldTypeOption({
  fieldType,
  onSelect,
}: {
  fieldType: FieldType
  onSelect: () => void
}) {
  const {displayName} = fieldType
  const Icon = getIconByFieldType(fieldType.key)
  return (
    <button
      className="inline-flex w-20 flex-col items-center gap-2 rounded p-4 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-secondary"
      onClick={onSelect}
    >
      <Icon className="h-12 w-12 shrink-0 text-black" />
      <p className="text-sm font-medium">{displayName}</p>
    </button>
  )
}
